import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";

import "../styles.scss";

export const christmasFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <rect
        x="23"
        y="50"
        width="50"
        height="50"
        rx="2"
        fill={frameBackgroundColor}
      />
      <path
        d="M63.6369 50L64.2838 46.857C64.3339 46.614 64.2685 46.362 64.1078 46.1712C63.9454 45.9795 63.7049 45.8688 63.4499 45.8688H62.3253L60.8385 42.2564C60.7093 41.9433 60.3974 41.7375 60.0497 41.7375H59.3263C63.5017 38.635 66 33.808 66 28.5705C66 23.8534 63.9276 19.3462 60.314 16.204C56.6657 13.0312 51.9641 11.5754 47.0533 12.1075C39.3128 12.9469 33.0335 19.0256 32.1223 26.561C31.4797 31.8763 33.3906 37.0114 37.3637 40.6494L38.5291 39.4463C34.9504 36.1711 33.2308 31.5441 33.8096 26.7535C34.6308 19.9742 40.2793 14.5052 47.2429 13.7492C51.6529 13.2725 55.8972 14.5788 59.1809 17.4343C62.4341 20.2642 64.2999 24.3227 64.2999 28.5705C64.2999 34.108 61.2006 39.1348 56.1956 41.7375H51.5492V38.4325H56.6495C56.9283 38.4325 57.1893 38.2995 57.3482 38.0773C57.5072 37.8542 57.5429 37.5699 57.4451 37.3163L55.326 31.8226H55.7995C56.0783 31.8226 56.3392 31.6895 56.4982 31.4673C56.6572 31.2442 56.6929 30.96 56.5951 30.7063L54.4759 25.2126H54.9494C55.2835 25.2126 55.5852 25.0234 55.723 24.7276C55.8615 24.4326 55.8088 24.0864 55.5895 23.8418L49.6392 17.2319C49.3153 16.8733 48.6829 16.8733 48.359 17.2319L42.4087 23.8418C42.1894 24.0856 42.1367 24.4326 42.2752 24.7276C42.4129 25.0234 42.7147 25.2126 43.0488 25.2126H43.5223L41.4031 30.7063C41.3053 30.96 41.3419 31.2442 41.5 31.4673C41.659 31.6895 41.9199 31.8226 42.1987 31.8226H42.6722L40.553 37.3163C40.4553 37.5699 40.4918 37.8542 40.6499 38.0773C40.8089 38.2995 41.0699 38.4325 41.3487 38.4325H46.449V41.7375H37.9485C37.6008 41.7375 37.2889 41.9433 37.1588 42.2564L35.6729 45.8688H34.5483C34.2933 45.8688 34.0527 45.9795 33.8912 46.1712C33.7306 46.362 33.6651 46.614 33.7153 46.857L34.3613 50H63.6369ZM44.6953 31.2863C44.7931 31.0327 44.7565 30.7484 44.5984 30.5254C44.4386 30.3031 44.1776 30.1701 43.8988 30.1701H43.4253L45.5445 24.6764C45.6423 24.4227 45.6057 24.1385 45.4476 23.9154C45.3201 23.7361 45.1246 23.6146 44.9087 23.575L48.9991 19.0314L53.0895 23.5758C52.8736 23.6154 52.6789 23.7369 52.5506 23.9162C52.3916 24.1393 52.3559 24.4235 52.4537 24.6772L54.5728 30.1701H54.0994C53.8206 30.1701 53.5596 30.3031 53.4006 30.5254C53.2417 30.7484 53.206 31.0327 53.3037 31.2863L55.4229 36.78H42.5753L44.6953 31.2863ZM48.149 38.4325H49.8491V41.7375H48.149V38.4325ZM38.524 43.39H59.4742L60.4943 45.8688H37.5039L38.524 43.39Z"
        fill={frameColor}
      />
      <path
        d="M51.55 31.3381C51.3162 30.9426 50.7982 30.8096 50.3709 30.9983C49.164 31.5314 47.8355 31.8117 46.5207 31.8213C46.0514 31.8248 45.6394 32.1577 45.599 32.6122C45.5586 33.0669 45.9052 33.4704 46.3747 33.4746C46.4094 33.4749 46.4441 33.4751 46.4788 33.4751C48.1232 33.4751 49.746 33.1186 51.2204 32.438C51.6445 32.2422 51.7838 31.7339 51.55 31.3381Z"
        fill={frameColor}
      />
      <path
        d="M50.7455 26.3374C51.0833 26.0204 51.0497 25.4955 50.6989 25.1922C50.3483 24.889 49.8137 24.9226 49.4716 25.2348C48.5275 26.0965 47.418 26.754 46.2025 27.1717C45.7601 27.3238 45.4833 27.7695 45.5988 28.2116C45.7143 28.6539 46.1783 28.9244 46.623 28.7785C48.1668 28.2718 49.5692 27.4414 50.7455 26.3374Z"
        fill={frameColor}
      />
      <path
        d="M60.8997 23.5601C60.8997 24.0164 60.5191 24.3863 60.0497 24.3863C59.5802 24.3863 59.1996 24.0164 59.1996 23.5601C59.1996 23.1038 59.5802 22.7339 60.0497 22.7339C60.5191 22.7339 60.8997 23.1038 60.8997 23.5601Z"
        fill={frameColor}
      />
      <path
        d="M37.0985 23.5601C37.0985 24.0164 37.479 24.3863 37.9485 24.3863C38.418 24.3863 38.7985 24.0164 38.7985 23.5601C38.7985 23.1038 38.418 22.7339 37.9485 22.7339C37.479 22.7339 37.0985 23.1038 37.0985 23.5601Z"
        fill={frameColor}
      />
      <path
        d="M62.5998 28.5176C62.5998 28.9739 62.2192 29.3438 61.7498 29.3438C61.2803 29.3438 60.8997 28.9739 60.8997 28.5176C60.8997 28.0613 61.2803 27.6913 61.7498 27.6913C62.2192 27.6913 62.5998 28.0613 62.5998 28.5176Z"
        fill={frameColor}
      />
      <path
        d="M35.3984 28.5176C35.3984 28.9739 35.7789 29.3438 36.2484 29.3438C36.7179 29.3438 37.0985 28.9739 37.0985 28.5176C37.0985 28.0613 36.7179 27.6913 36.2484 27.6913C35.7789 27.6913 35.3984 28.0613 35.3984 28.5176Z"
        fill={frameColor}
      />
      <path
        d="M60.0497 33.4751C60.0497 33.9314 59.6691 34.3013 59.1996 34.3013C58.7302 34.3013 58.3496 33.9314 58.3496 33.4751C58.3496 33.0187 58.7302 32.6488 59.1996 32.6488C59.6691 32.6488 60.0497 33.0187 60.0497 33.4751Z"
        fill={frameColor}
      />
      <path
        d="M37.9485 33.4751C37.9485 33.9314 38.3291 34.3013 38.7985 34.3013C39.268 34.3013 39.6486 33.9314 39.6486 33.4751C39.6486 33.0187 39.268 32.6488 38.7985 32.6488C38.3291 32.6488 37.9485 33.0187 37.9485 33.4751Z"
        fill={frameColor}
      />
      <path
        d="M57.4995 19.4289C57.4995 19.8852 57.119 20.2551 56.6495 20.2551C56.18 20.2551 55.7995 19.8852 55.7995 19.4289C55.7995 18.9725 56.18 18.6026 56.6495 18.6026C57.119 18.6026 57.4995 18.9725 57.4995 19.4289Z"
        fill={frameColor}
      />
      <path
        d="M40.4986 19.4289C40.4986 19.8852 40.8792 20.2551 41.3487 20.2551C41.8182 20.2551 42.1987 19.8852 42.1987 19.4289C42.1987 18.9725 41.8182 18.6026 41.3487 18.6026C40.8792 18.6026 40.4986 18.9725 40.4986 19.4289Z"
        fill={frameColor}
      />
      <foreignObject
        width="44%"
        height="41px"
        style={{ borderRadius: "3px" }}
        x="27"
        y="54">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="102">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
